import $ from "jquery";
(function() {
  var jQuery = $;
  var $$1 = jQuery;
  jQuery.fn.customInput = function() {
    return $$1(this).each(function() {
      if ($$1(this).is("[type=checkbox],[type=radio]")) {
        var input = $$1(this);
        var label = input.siblings('label[for="' + input.attr("id") + '"]:first');
        if (!label.length) {
          label = input.closest('label[for="' + input.attr("id") + '"]:first');
        }
        input.add(label).wrapAll('<div class="custom-' + input.attr("type") + '"></div>');
        label.hover(function() {
          $$1(this).addClass("hover");
        }, function() {
          $$1(this).removeClass("hover");
        });
        input.bind("updateState", function() {
          input.is(":checked") ? label.addClass("checked") : label.removeClass("checked checkedHover checkedFocus");
        }).trigger("updateState").click(function() {
          $$1('input[name="' + $$1(this).attr("name") + '"]').trigger("updateState");
        }).focus(function() {
          label.addClass("focus");
          if (input.is(":checked")) {
            $$1(this).addClass("checkedFocus");
          }
        }).blur(function() {
          label.removeClass("focus checkedFocus");
        });
      }
    });
  };
})();
